import React from 'react'

interface KitBuilderProps {
  kitBuilderDistributorId: string | undefined
  kitBuilderKey: string | undefined
}

export const KitBuilder = (props: KitBuilderProps) => {
  const kitBuilderSrc =
    props.kitBuilderDistributorId && props.kitBuilderKey
      ? `https://api.kitbuilder.co.uk/api/bootstrapper?distributorId=${props.kitBuilderDistributorId}&key=${props.kitBuilderKey}&secureFrame=true`
      : ''
  return (
    <React.Fragment>
      <iframe
        title="Kit Builder"
        src={kitBuilderSrc}
        frameBorder="0"
        width="100%"
        height="1000px"
        allow="fullscreen"
      ></iframe>
    </React.Fragment>
  )
}
